<template>
  <li class="bg-white rounded-lg py-4 px-4 list-none gap-4 items-center border-[1px] border-gray-300">
    <article class="flex flex-wrap h-auto mx-4">
      <!-- Top section -->
      <div class="inline-flex flex-wrap w-full">
        <!-- Main information -->
        <div class="text-lg mb-2 w-full flex flex-wrap items-center gap-1">
          <div class="h-6 w-96 bg-gray-200 rounded animate-pulse"></div>
        </div>
        
        <!-- Location -->
        <div class="text-gray-600 block text-sm w-full">
          <div class="h-5 w-36 bg-gray-200 rounded animate-pulse"></div>
        </div>

        <!-- Status signifiers -->
        <div class="flex items-center text-sm flex-wrap mt-2 w-full gap-6">
          <!-- Job status -->
          <div class="flex items-center gap-1">
            <div class="h-2 w-2 rounded-full bg-gray-200 animate-pulse"></div>
            <div class="h-5 w-20 bg-gray-200 rounded animate-pulse"></div>
            <div class="h-5 w-16 bg-gray-200 rounded animate-pulse"></div>
          </div>

          <!-- Status dropdown -->
          <div class="h-8 w-32 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </article>
  </li>
</template> 